module.exports = require('../../es/promise');

require('../../modules/esnext.promise.all-settled');
require('../../modules/esnext.promise.try');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/features/promise/index.js
// module id = 191
// module chunks = 0